import type { ContactSearchEntry } from "../types/common";

export const isContactSearchEntryRevealed = (v: ContactSearchEntry): boolean =>
    v !== null && typeof v === "object" && v.isRevealed;
